import classNames from 'classnames';
import { Divider } from 'antd';

import { SelectDrawer } from '@Components/Base';
import { OptionExtended } from '@Components/types/options';

import styles from './presentation-desktop-request-header.module.css';

interface PresentationDesktopRequestHeaderProps {
  caption: string;
  labelSelectOption?: string;
  selectOptions?: OptionExtended[];
  children?: React.ReactNode;
  selectedValue?: string;
  showSelect?: boolean;
  handleSelect?: (label: string, value: string | null) => void;
  onRequestSelectorOpen?: () => void;
}

const PresentationDesktopRequestHeader: React.FC<
  PresentationDesktopRequestHeaderProps
> = ({
  caption,
  children,
  selectOptions,
  handleSelect,
  selectedValue = '',
  showSelect = true,
  onRequestSelectorOpen,
  labelSelectOption,
}) => {
  return (
    <div className={classNames(styles.presentationHeader)}>
      <div className={styles.caption}>{caption}</div>
      <div className={styles.presentationActions}>
        {showSelect && (
          <div className={styles.presentationSelectTypeSection}>
            <span>{labelSelectOption}</span>
            <Divider className={styles.presentationDivider} type="vertical" />
            {selectOptions && (
              <SelectDrawer
                items={selectOptions}
                caption={selectedValue}
                title="Select Request Type"
                handleSelect={handleSelect}
                onOpen={onRequestSelectorOpen}
                showCounter
              />
            )}
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  );
};

export default PresentationDesktopRequestHeader;
